export default __webpack_public_path__ + "images/2c90014bf2c62886e1a1c28c83e12679-DCASync.svg";